/**
 * ユーザログ
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CustomizedTable from '../../../utils/table'
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import {
    Paper,
    Grid,
    InputBase,
    Typography,
    Button,
    InputLabel,
    Select,
    ClickAwayListener,
    MenuItem,
    MenuList,
    Tooltip,
    InputAdornment,
} from '@material-ui/core';
import { getUserLog, userLogDownload } from 'mdoc/admin/axios/user'
import { getUserInfo } from 'mdoc/admin/axios'
import { getParentId } from 'mdoc/admin/axios/content'
import { dictionary } from 'mdoc/admin/axios'
import * as config from 'mdoc/admin/axios/config'
import Toast from 'mdoc/utils/toast';
import { MuiPickersUtilsProvider, DateTimePicker } from 'material-ui-pickers';
import { getLang } from 'mdoc/utils';
import DateFnsUtils from '@date-io/date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import { dateFormat } from 'mdoc/utils'
import {
    Clear,
} from '@material-ui/icons';
const localeMap = {
    1: jaLocale,
    2: zhCNLocale,
    3: enLocale,
};
const lang = getLang();

const BootstrapInput = withStyles(theme => ({
    root: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        },
        width: '130px'
    },
    input: {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 12,
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);
const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
        minWidth: '700px',
        whiteSpace: 'nowrap',
    },
    bootstrapFormLabel: {
        minWidth: '100px',
        maxWidth: '200px',
    },
    // bootstrapRoot: {
    //     'label + &': {
    //         marginTop: theme.spacing.unit * 3,
    //     }
    // },
    // bootstrapSelect: {
    //     backgroundColor: theme.palette.common.white,
    //     border: '1px solid #ced4da!important',
    //     paddingLeft: '5px',
    // },
    buttons: theme.palette.buttons,
    item: {
        color: '#ffffff',
    },
    tip: {
        background: '#2096fb',
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none'
    },
    searchRoot: {
        display: 'flex',
        alignItems: 'center',
        boxShadow: 'none',
        border: '1px solid #ced4da',
        borderRadius: '0px',
        height: '29px'
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        borderRadius: 0,
        boxShadow: 'none',
        height: '29px'
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },
})

class User_Log extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        permissions: [],
        pagination: {
            pageNumber: 1,
            pageSize: 25,
            // page: 1,
            count: 0,
            sidx: '',
            sord: ''
        },
        dictWord: {
            'download': '',
            'effective_time': '',
            'user_id': '',
            'user_identity': '',
            'content_id': '',
            'book_title': '',
            'category': '',
            'release_method': '',
            'effective_start_time': '',
            'effective_date': '',
            'release_destination': '',
            'mixture': '',
            'streaming': '',
            'web': '',
            'ios iphone': '',
            'ios ipad': '',
            'android phone': '',
            'android pad': '',
            'user_log': '',
            'msg_error_record_not_found': '',
        },
        formData: {
            startDateTime: {
                value: null//new Date(),
            },
            endDateTime: {
                value: null//new Date(new Date().setDate(new Date().getDate()+6)),
            },
            idStatus: {
                width: '',
                value: 0,
            },
            search: {
                value: null//new Date(new Date().setDate(new Date().getDate()+6)),
            }
        },
        search: '',
        userId: '',
        bookId: '',
        idStatus: config['CONTENT_USER'],
        downlaodWay: config['DOWNLOAD_WAY'],
        browser: config['BROWSER_TYPE'],
        TooltipOpen: [],
        docMstBookCategoryList: null,
        categoryName: '',
    }
    componentWillMount() {
        this.start(this.state);
    }
    componentDidMount() {
        let formData = this.state.formData;
        formData['idStatus'] = Object.assign(this.state['formData']['idStatus']);
        this.setState({
            formData: formData
        });
    }
    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }

    fetch = (params = {}) => {
        this.setState({ loading: true })
        getUserLog({
            ...params,
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            if (data.results === undefined) {
                Toast.info(this.state.dictWord.msg_error_record_not_found)
            }
            this.setState({
                loading: false,
                data: data.results !== undefined ? data.results : [],
                pagination: pagination,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }

    handleSearch = event => {
        let idStatus = this.state.formData.idStatus.value
        let startDateTime = this.state.formData.startDateTime.value
        let endDateTime = this.state.formData.endDateTime.value
        let search = this.state.formData.search.value
        if (!startDateTime) {
            startDateTime = ''
        } else {
            startDateTime = dateFormat(new Date(startDateTime), 'yyyy/MM/dd hh:mm:ss')
        }
        if (!endDateTime) {
            endDateTime = ''
        } else {
            endDateTime = dateFormat(new Date(endDateTime), 'yyyy/MM/dd hh:mm:ss')
        }
        this.setState({
            search: search,
            pagination: Object.assign(this.state.pagination, { pageNumber: 1 }),
        }, () => {
            let formData = {
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                userId: "",
                bookId: "",
                userName: "",
                title: "",
                pageNumber: this.state.pagination.pageNumber,
                pageSize: this.state.pagination.pageSize,
                sidx: this.state.pagination.sidx,
                sord: this.state.pagination.sord,
            }

            switch (parseInt(idStatus)) {
                case 0:
                    formData.userId = this.state.search;
                    break;
                case 1:
                    formData.userName = this.state.search;
                    break;
                case 2:
                    formData.bookId = this.state.search;
                    break;
                default:
                    formData.title = this.state.search;
                    break;
            }
            this.fetch(formData);
        });
    }
    handleDownload = () => {
        let idStatus = this.state.formData.idStatus.value
        let startDateTime = this.state.formData.startDateTime.value
        let endDateTime = this.state.formData.endDateTime.value
        if (!startDateTime) {
            startDateTime = ''
        } else {
            startDateTime = dateFormat(new Date(startDateTime), 'yyyy/MM/dd hh:mm:ss')
        }
        if (!endDateTime) {
            endDateTime = ''
        } else {
            endDateTime = dateFormat(new Date(endDateTime), 'yyyy/MM/dd hh:mm:ss')
        }
        let dicWord = this.state.dictWord.user_log
        let date = dateFormat(new Date(), 'yyyyMMddhhmmss')
        userLogDownload(dicWord + '_' + date + '.xlsx', {
            startDateTime: startDateTime,
            endDateTime: endDateTime,
            userId: parseInt(idStatus) === 0 ? this.state.search : '',
            userName: parseInt(idStatus) === 1 ? this.state.search : '',
            bookId: parseInt(idStatus) === 2 ? this.state.search : '',
            title: parseInt(idStatus) === 3 ? this.state.search : '',
        }).then(res => {
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    handleChange(filed, event) {
        let formData = this.state.formData;
        if (filed === 'startDateTime' || filed === 'endDateTime') {
            formData[filed] = Object.assign(this.state['formData'][filed], { value: event });
        } else {
            formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        }
        this.setState({
            formData: formData,
        });
    }
    handleTableChange = (event, pagination) => {
        let idStatus = this.state.formData.idStatus.value;
        let startDateTime = this.state.formData.startDateTime.value;
        let endDateTime = this.state.formData.endDateTime.value;
        let userId = parseInt(idStatus) === 0 ? this.state.search : '';
        let userName = parseInt(idStatus) === 1 ? this.state.search : '';
        let bookId = parseInt(idStatus) === 2 ? this.state.search : '';
        let title = parseInt(idStatus) === 3 ? this.state.search : '';
        if (!startDateTime) {
            startDateTime = ''
        } else {
            startDateTime = dateFormat(new Date(startDateTime), 'yyyy/MM/dd hh:mm:ss')
        }
        if (!endDateTime) {
            endDateTime = ''
        } else {
            endDateTime = dateFormat(new Date(endDateTime), 'yyyy/MM/dd hh:mm:ss')
        }
        this.fetch({
            startDateTime,
            endDateTime,
            userId,
            bookId,
            userName,
            title,
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }
    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })


    };
    handleTooltipOpens = (id, parentId) => event => {
        getParentId(
            { parentIds: parentId }
        ).then((data) => {
            let docMstBookCategoryList = data.results;
            let TooltipOpen = this.state.TooltipOpen;
            if (!TooltipOpen.includes(id)) {
                TooltipOpen.push(id);
            }
            this.setState({
                TooltipOpen: TooltipOpen,
                docMstBookCategoryList: docMstBookCategoryList
            })
        })
    }
    handleTooltipClose = (id) => event => {
        let TooltipOpen = this.state.TooltipOpen;
        if (TooltipOpen.includes(id)) {
            let index = TooltipOpen.indexOf(id);
            TooltipOpen.splice(index, 1);
        }
        this.setState({ TooltipOpen: TooltipOpen });
    };
    //Cleaning time input box
    clearStartTime = () => {
        let formData = this.state.formData;
        formData['startDateTime'] = Object.assign(this.state['formData']['startDateTime'], { value: null });
        this.setState({
            formData: formData
        });
    }
    clearEndTime = () => {
        let formData = this.state.formData;
        formData['endDateTime'] = Object.assign(this.state['formData']['endDateTime'], { value: null });
        this.setState({
            formData: formData
        });
    }
    onKeyPress=(event)=>{
        let enter = event.keyCode;
        if (enter === 13) {
            this.handleSearch();
        }
    }
    render() {
        const { classes } = this.props;
        // const {dictWord} = this.state.dictWord;
        const columns = [{
            title: this.state.dictWord.user_id,
            dataIndex: 'docTblUser.userCode',
            width: '100px',
            render: (text, record) => {
                return record.docTblUser.userCode
            }
        }, {
            title: this.state.dictWord.user_identity,
            dataIndex: 'docTblUser.name',
            width: '100px',
            render: (text, record) => {
                return record.docTblUser.name
            }

        }, {
            title: this.state.dictWord.content_id,
            dataIndex: 'docTblBook.bookCode',
            width: '100px',
            render: (text, record) => {
                return record.docTblBook.bookCode
            }
        }, {
            title: this.state.dictWord.book_title,
            width: '100px',
            render: (text, record) => {
                return record.docTblBook.title
            }
        }, {
            title: this.state.dictWord.category,
            width: '100px',
            toolTipDisabled: true,
            render: (text, record) => {
                let category = <span className={classes.link}>{record.docTblBook.docMstBookCategory.categoryName}</span>;
                if (record.docTblBook.docMstBookCategory.parentIds.length > 0) {
                    category = <ClickAwayListener onClickAway={this.handleTooltipClose(record.id)}>
                        <Tooltip
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            onClose={this.handleTooltipClose(record.id)}
                            open={this.state.TooltipOpen.includes(record.id)}
                            classes={{ tooltip: classes.tip }}
                            placement="top"
                            title={this.state.docMstBookCategoryList ? <MenuList>
                                {this.state.docMstBookCategoryList.map((item, index) => {
                                    return <MenuItem key={index} style={{ marginLeft: 20 * (item.depth - 1) }} className={classes.item}><span>{item.categoryName}</span></MenuItem>;
                                })}
                            </MenuList> : ''}
                        >
                            <span className={classes.link} onClick={this.handleTooltipOpens(record.id, record.docTblBook.docMstBookCategory.parentIds)}>{record.docTblBook.docMstBookCategory.categoryName}</span>
                        </Tooltip></ClickAwayListener>;
                }
                return category;
            }
        }, {
            title: this.state.dictWord.release_method,
            width: '100px',
            render: (text, record) => {
                if (record.docTblBook.docTblBookDetail['downloadWay'] === 0) {
                    return this.state.dictWord[this.state.downlaodWay[0]]
                } else if (record.docTblBook.docTblBookDetail['downloadWay'] === 1) {
                    return this.state.dictWord[this.state.downlaodWay[1]]
                } else {
                    return this.state.dictWord[this.state.downlaodWay[2]]
                }
            }
        }, {
            title: this.state.dictWord.release_destination,
            dataIndex: 'browser',
            width: '100px',
            toolTipDisabled: true,
            render: (text, record) => {
                if (record.clientType === 0) {
                    return this.state.dictWord[this.state.browser[0]]
                } else if (record.clientType === 1) {
                    return this.state.dictWord[this.state.browser[1]]
                } else if (record.clientType === 2) {
                    return this.state.dictWord[this.state.browser[2]]
                } else if (record.clientType === 3) {
                    return this.state.dictWord[this.state.browser[3]]
                } else if (record.clientType === 4) {
                    return this.state.dictWord[this.state.browser[4]]
                }
            }
        }, {
            title: this.state.dictWord.effective_start_time,
            dataIndex: 'readStartDateStr',
            width: '150px',
        }, {
            title: this.state.dictWord.effective_date,
            dataIndex: 'readingTimeStr',
            width: '70px',
        },
        ]
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="flex-start" alignItems="center" className={classes.margin} style={{ minWidth: '1062px' }}>
                    <Grid item xs={12} md={1} style={{ maxWidth: '100px', lineHeight: '32px' }}>
                        <InputLabel shrink htmlFor="effectiveTime">
                            {this.state.dictWord.effective_time}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                            <div className="picker">
                                <DateTimePicker
                                    ampm={false}
                                    format="yyyy/MM/dd HH:mm"
                                    value={this.state.formData.startDateTime.value}
                                    onChange={this.handleChange.bind(this, 'startDateTime')}
                                />
                                <Clear
                                    color="disabled"
                                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                    onClick={this.clearStartTime}
                                />
                            </div>
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <span style={{ marginLeft: '10px', marginRight: '10px', display: 'inlineBlock', lineHeight: '30px' }}>~</span>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                            <div className="picker">
                                <DateTimePicker
                                    ampm={false}
                                    format="yyyy/MM/dd HH:mm"
                                    value={this.state.formData.endDateTime.value}
                                    onChange={this.handleChange.bind(this, 'endDateTime')}
                                />
                                <Clear onClick={this.clearEndTime} />
                            </div>
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} md={2} style={{ marginLeft: '44px', maxWidth: '160px', minWidth: '160px' }}>
                        <Select
                            value={this.state.formData.idStatus.value}
                            onChange={this.handleChange.bind(this, 'idStatus')}
                            id="idStatus"
                            name="idStatus"
                            input={<BootstrapInput />}
                        >
                            {this.state.idStatus.map((item, index) => {
                                return <MenuItem key={index} value={index}>{this.state.dictWord[item]}</MenuItem>
                            })}
                        </Select>
                    </Grid>
                    <Grid item xs={12} md={3} style={{ maxWidth: '200px', minWidth: '200px' }}>
                        <Paper className={classes.searchRoot}>
                            <InputBase
                                className={classes.input}
                                placeholder="Search…"
                                inputProps={{ 'aria-label': 'Search…' }}
                                onChange={this.handleChange.bind(this, 'search')}
                                value={this.state.formData.search.value ? this.state.formData.search.value : ''}
                                onKeyUp={this.onKeyPress.bind(this)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        {this.state.formData.search.value ?
                                            <CloseIcon
                                                color="disabled"
                                                style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                                onClick={() => {
                                                    let formData = this.state.formData;
                                                    formData['search'].value = null;
                                                    this.setState({
                                                        formData,
                                                    });
                                                }}
                                            /> : ''}
                                    </InputAdornment>
                                }
                            />
                            <Button color="primary" variant="contained" size="small" aria-label="search" className={classes.iconButton} onClick={this.handleSearch.bind(this)}>
                                <SearchIcon />
                            </Button>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={1} style={{ marginLeft: '44px', maxWidth: '100px', minWidth: '100px' }}>
                        {getUserInfo().logExport === 0 ? null : <Button variant="contained" color="primary" onClick={this.handleDownload} size="medium" className={classes.button}>
                            {this.state.dictWord.download}
                        </Button>}
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
            </div>
        )
    }
}

User_Log.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(User_Log);